module.exports = __webpack_public_path__ + "img/file_open_white_24dp.395598ed.svg";